import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-label" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_3 = { class: "p-label" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Password"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Confirm password"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*")
], -1)
const _hoisted_7 = { class: "p-label" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_9 = { class: "p-label" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_11 = { class: "p-label" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_13 = { class: "p-field mb4" }
const _hoisted_14 = { class: "p-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
      () => {
        $setup.v$.$touch();
        $setup.handleSubmit(!$setup.v$.$invalid);
      }
    , ["prevent"])),
    class: "_form"
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.title.$invalid && $setup.v$.title.$dirty }])
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('company_page.company_name')), 1),
        _hoisted_2
      ]),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.title.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.title.$model) = $event)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.title.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.email.$invalid && $setup.v$.email.$dirty }])
    }, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('email')), 1),
        _hoisted_4
      ]),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.email.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.v$.email.$model) = $event)),
        onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.email.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.password.$invalid && $setup.v$.password.$dirty }])
    }, [
      _hoisted_5,
      _createVNode(_component_InputText, {
        type: "password",
        modelValue: $setup.v$.password.$model,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.v$.password.$model) = $event)),
        onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.v$.password.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.password_confirmation.$invalid && $setup.v$.password_confirmation.$dirty }])
    }, [
      _hoisted_6,
      _createVNode(_component_InputText, {
        type: "password",
        modelValue: $setup.v$.password_confirmation.$model,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.v$.password_confirmation.$model) = $event)),
        onBlur: _cache[7] || (_cache[7] = ($event: any) => ($setup.v$.password_confirmation.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.address.$invalid && $setup.v$.address.$dirty }])
    }, [
      _createElementVNode("span", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('address')), 1),
        _hoisted_8
      ]),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.address.$model,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.v$.address.$model) = $event)),
        onBlur: _cache[9] || (_cache[9] = ($event: any) => ($setup.v$.address.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.name.$invalid && $setup.v$.name.$dirty }])
    }, [
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('company_page.contact_person')), 1),
        _hoisted_10
      ]),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.name.$model,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.v$.name.$model) = $event)),
        onBlur: _cache[11] || (_cache[11] = ($event: any) => ($setup.v$.name.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.phone.$invalid && $setup.v$.phone.$dirty }])
    }, [
      _createElementVNode("span", _hoisted_11, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('company_page.phone')), 1),
        _hoisted_12
      ]),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.phone.$model,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.v$.phone.$model) = $event)),
        onBlur: _cache[13] || (_cache[13] = ($event: any) => ($setup.v$.phone.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("label", _hoisted_13, [
      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('company_page.available_tokens')), 1),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.tokens.$model,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.v$.tokens.$model) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_Button, {
      class: "p-button-big _full-width mt-3",
      type: "submit"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('company_page.add_company')), 1)
      ]),
      _: 1
    })
  ], 32))
}